import Card from "./Card";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";

import "./index.sass";

const Page = () => {
  const cardsDataRow1 = [
    {
      title: "TOP CSP STORIES",
      onClick: () => (window.location.href = Config.CSP),
    },
    {
      title: "INFOSYS ENTERTAINMENT\nPLATFORM",
      onClick: () => (window.location.href = Config.ENTERTAINMENT),
    },
    {
      title: "INFOSYS CONNECTIVITY\nPLATFORM",
      onClick: () => (window.location.href = Config.CONNECTIVITY),
    },
  ];

  const cardsDataRow2 = [
    {
      title: "Gen-AI powered Network Plan and Build",
      onClick: () => (window.location.href = Config.AWS),
      image: "aws.png",
    },
    {
      title: "AI-First, Agile, Integrated IT and Network Operations",
      onClick: () => (window.location.href = Config.BMC),
      image: "bmc.png",
    },
    {
      title: "INTELLIGENT EXPERIENCE (IX) USING AI-FIRST AUTOMATION",
      onClick: () => setCurrentPage(1),
      image: "pega.png",
    },
    {
      title: "AI @ Edge",
      onClick: () => setCurrentPage(2),
      image: "mef.png",
    },
  ];

  return (
    <div className="page-cero">
      <div className="page-cero-body">
        <div style={{ width: "var(--width-1337)", margin: "auto" }}>
          <div className="page-cero-body-elements-row">
            {cardsDataRow1.map((cardData, index) => (
              <Card key={index} {...cardData} />
            ))}
          </div>
        </div>
        <div className="page-cero-body-elements">
          {cardsDataRow2.map((cardData, index) => (
            <Card key={index} {...cardData} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Page;
